/// <amd-module name="TFS/Admin/Views/ProfileSettings/TimeAndLocaleView/Contracts/DataModels" />
import { WebSessionToken } from "VSS/Platform/Contracts/Authentication";

export interface IProfileUserPreferencesData {
    userIdentity: {
        id: string;
        subjectDescriptor: string
    }
    culture: string;
    datePattern: string;
    timePattern: string;
    timeZone: string;
    namedSessionToken: WebSessionToken;
    oldProfileUrl: string;
    profilePreferences: IProfilePreferencesModel;
}

export interface IProfilePreferencesModel {
    timeZones: [ITimeZoneInfoModel];
    cultures: [ICultureInfoModel];
    datePatterns: [IPatternModel];
    timePatterns: [IPatternModel];
}

export interface ITimeZoneInfoModel {
    displayName: string;
    id: string;
}

export interface ICultureInfoModel {
    displayName: string;
    lcid: number;
    language: string;
}

export interface IPatternModel {
    format: string;
    displayFormat: string;
}